import { render, staticRenderFns } from "./generalRecognition.vue?vue&type=template&id=31d3e4d0&scoped=true&"
import script from "./generalRecognition.vue?vue&type=script&lang=js&"
export * from "./generalRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3e4d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d3e4d0')) {
      api.createRecord('31d3e4d0', component.options)
    } else {
      api.reload('31d3e4d0', component.options)
    }
    module.hot.accept("./generalRecognition.vue?vue&type=template&id=31d3e4d0&scoped=true&", function () {
      api.rerender('31d3e4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/generalRecognition.vue"
export default component.exports